import {
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_CartCheckoutData,
  STORE_SHEDULEDateNTime,
  STORE_MERCHANT_SCROLL,
  STORE_DineType,
  STORE_Addons,
  STORE_Cart,
} from "../../database/store-names";
import {
  GET_SELECTED_MERCHANT_OR_PRODCUCT,
  GET_CART_SELECT_MERCHATS_ZONE,
  GET_SET_STORED_DATA,
  GET_ADDON_UOM,
  GET_CART,
} from "../../database/get-stored-data";
import {
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  HEADER_TAB_SETUP,
  GET_CART_COUNT,
  KEY_GENERATOR,
} from "../../functions/funtion";
import {
  SET_STORE_CART_SELECT_MERCHATS_ZONE,
  SET_STORE_ADDONUOM,
  SET_STORE_CART,
  CLEAR_CART_MEMORY_CACHE,
} from "../../database/store-data";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../classes/dto-selected-merchant-or-product";
import {
  PT_GROCERY_PRODUCT_LIST,
  PT_GROCERY_PRODUCT,
} from "../../routes/stack/paths/pt-grocery";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { api_DaitonnAnalytical } from "../../connection/api/api-Machine-Learning";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { api_LoadProductToPID } from "../../connection/api/api-product";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { F_Fammily, Font } from "../../util/config-fonts";
import { isMobile } from "react-device-detect";
import { PT_CART } from "../../routes/stack/paths/pt-cart";
import { PT_HOME } from "../../routes/stack/paths/pt-home";
import { Colors } from "../../util/colors";
import PgProductCategoryNMerchant from "../home/components/pg-product/pg-product-category-merchant";
import PgProductDescNGDesc from "../home/components/pg-product/pg-product-description-genaraldescription";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import RecommendedItems from "../../components/render-drawer-recomended-items/render-drawer-recomended-items";
import PgProductAddons from "../home/components/pg-product/pg-product-addons";
import PgProductImage from "../home/components/pg-product/pg-product-image";
import PgProductPrice from "../home/components/pg-product/pg-product-price";
import PgProductNote from "../home/components/pg-product/pg-product-note";
import PgProductUom from "../home/components/pg-product/pg-product-uom";
import QtyPlysMinus from "../home/components/pg-product/pg-product-qty";
import Alert from "../../components/Alert";
import React from "react";
import "../../styles/css/pg-product.css";
import { ToastMessage } from "../../components/toast-notification/toast";

export default class GroceryProduct extends React.PureComponent {
  constructor(props) {
    super(props);
    this.CartCache = [];
    this.state = {
      IsLoading: true,
      PID: 0,
      LineID: 0,
      AddonLineID: 0,
      Category: 0,
      FromPage: "",
      NavigatePage: "",
      ProductAddOnList: [],
      Product: [],
      ProductImageUrl: "",
      HasProductImage: false,
      ProductUOMList: [],
      AddonSelectedGUID: [],
      ProductDesc: "",
      Note: "",
      AddOnDesc: "",
      AddonPIDUseqID: "",
      ClearAddonsTrue: "NO",
      DetailProdutUP: 0,
      Qty: 1,
      HandlingCost: 0,
      Total: 0,
      DisplayGrantTotal: 0,
      selectedUomRadioButton: 0,
      MaxAddOnSelection: 0,
      UomSelectedUseqID: 0,
      FillteredProductAddonList: [],
      disabled: false,
      RecomendedItemDrawer: false,
      RecommendedDataList: [],
      isReacomended: 0,
      SelectedNuberArray: [],
    };
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    ENCRYPT_STORAGE.removeItem(STORE_MERCHANT_SCROLL);
    this.setState(
      {
        PID: this.props.params.pid,
        LineID: this.props.params.lineid,
        AddonLineID: this.props.params.adonlineid,
        Category: this.props.params.category,
        FromPage: this.props.params.frompage,
        NavigatePage: this.props.params.navigatepage,
        isReacomended: this.props.params.isrecommended,
      },
      async () => {
        await this.LoadProduct();
      },
    );

    await api_DaitonnAnalytical();
    await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
      this.setState({ RecomendedItemDrawer: false });
      await this.PathDivert();
    });
  }

  async componentDidUpdate(prevProps) {
    const prevParams = prevProps.params || {};
    const nextParams = this.props.params || {};
    const hasRouteChanged =
      prevParams.pid !== nextParams.pid ||
      prevParams.lineid !== nextParams.lineid ||
      prevParams.adonlineid !== nextParams.adonlineid ||
      prevParams.isrecommended !== nextParams.isrecommended ||
      prevParams.frompage !== nextParams.frompage ||
      prevParams.navigatepage !== nextParams.navigatepage;

    if (!hasRouteChanged) {
      return;
    }

    await GET_SET_STORED_DATA();
    this.setState(
      {
        PID: nextParams.pid,
        LineID: nextParams.lineid,
        AddonLineID: nextParams.adonlineid,
        Category: nextParams.category,
        FromPage: nextParams.frompage,
        NavigatePage: nextParams.navigatepage,
        isReacomended: nextParams.isrecommended,
        IsLoading: true,
        Note: "",
        AddOnDesc: "",
        AddonPIDUseqID: "",
        AddonSelectedGUID: [],
        FillteredProductAddonList: [],
        ProductAddOnList: [],
        ProductUOMList: [],
        HasProductImage: false,
        selectedUomRadioButton: 0,
        UomSelectedUseqID: 0,
        Qty: 1,
        Total: 0,
        DetailProdutUP: 0,
      },
      async () => {
        await this.LoadProduct();
      },
    );
  }

  render() {
    const hasSelectableUom = this.state.ProductUOMList.length > 1;
    const hasAddons = this.state.FillteredProductAddonList.length > 0;
    const useCompactLayout = !hasSelectableUom && !hasAddons;
    const hasProductImage = this.state.HasProductImage;

    return (
      <div
        style={{
          minHeight: "100vh",
          paddingTop: "50px",
          paddingBottom: "16px",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {this.state.IsLoading ? (
          <div
            className="loader"
            style={{ marginTop: "90%", marginLeft: "45%" }}
          />
        ) : (
          <div
            style={{
              margin: "40px 10px 10px 10px",
              backgroundColor: "white",
              padding: useCompactLayout ? "24px 10px 20px 10px" : "45px 10px 24px 10px",
              minHeight: hasProductImage ? "calc(100vh - 96px)" : "auto",
              display: "flex",
              flexDirection: "column",
              boxShadow:
                CSP === "DT" || CSP === "MK"
                  ? "0px 4px 10px rgba(0, 0, 0, 0.3)"
                  : "",
            }}
            className={`fadeInUp animated${useCompactLayout ? " pgProductCompact" : ""}${hasProductImage ? "" : " pgProductNoImage"}`}
            data-wow-duration="300ms"
            data-wow-delay="0ms"
          >
            {hasProductImage ? (
              <PgProductImage
                imageUrl={this.state.ProductImageUrl}
                onImageError={() => {
                  this.setState({ HasProductImage: false });
                }}
                key={(e) => {
                  KEY_GENERATOR();
                }}
              />
            ) : null}

            <PgProductDescNGDesc
              IsAvailable={this.state.Product.A}
              Desc={this.state.ProductDesc}
              GDesc={this.state.Product.G}
              key={KEY_GENERATOR()}
            />

            <PgProductCategoryNMerchant
              Category={this.state.Category}
              Merchant={dto_selected_merchant_or_product.Merchant}
              key={KEY_GENERATOR()}
            />

            <PgProductPrice
              SP={this.state.DetailProdutUP}
              UD={this.state.Product.UD}
              key={KEY_GENERATOR()}
            />

            <PgProductUom
              data={this.state.ProductUOMList}
              Heading={"SELECT OPTIONS"}
              SectedButton={this.state.selectedUomRadioButton}
              OnClick={(e, rs, i) => {
                this.ClickUOMRadioButton(e, rs, i);
              }}
            />

            <PgProductAddons
              data={this.state.FillteredProductAddonList}
              OnClick={(e, item, rs, i) => {
                this.SelectAddonCheckbox(item, rs);
              }}
            />

            <PgProductNote
              txt={this.state.Note}
              onNoteChanged={(vl) => {
                this.onNoteChange(vl);
              }}
            />

            <QtyPlysMinus
              Qty={this.state.Qty}
              PlusPress={() => {
                this.onChangeQty(true);
              }}
              MinusPress={() => {
                this.onChangeQty(false);
              }}
              disabled={this.state.disabled}
            />

            <div
              className={`pgProductAddCartWrap${hasProductImage ? "" : " pgProductAddCartWrapNoImage"}`}
            >
              <button
                className="pgProductAddCartBtn"
                style={{
                  fontSize: Font.MainHeading,
                  color: Colors.FontColor,
                  backgroundColor: this.state.BtnDisableClr,
                  fontFamily: F_Fammily.Medium,
                  width: "100%",
                  marginLeft: "0%",
                  marginBottom: 0,
                }}
                disabled={this.state.disabled}
                onClick={() => this.onClickAddCart(this.state.Product)}
              >
                {this.state.BtnDescription}
              </button>
            </div>
          </div>
        )}

        <DrawerSheetBottom
          open={this.state.RecomendedItemDrawer}
          closeFunction={() => this.setState({ RecomendedItemDrawer: false })}
          displayCloseIcon="block"
          element={
            <>
              {this.state.RecommendedDataList.length > 0 ? (
                <RecommendedItems
                  data={this.state.RecommendedDataList}
                  NavigateToProductPage={(e) => {
                    this.props.navigate(
                      PT_GROCERY_PRODUCT.replace(":frompage", "product-list")
                        .replace(":navigatepage", this.state.NavigatePage)
                        .replace(":category", "category")
                        .replace(":pid", e.PI)
                        .replace(":lineid", 0)
                        .replace(":adonlineid", 0)
                        .replace(":isrecommended", 1),
                    );
                    this.setState({
                      RecomendedItemDrawer: false,
                      IsLoading: true,
                    });
                  }}
                />
              ) : (
                ""
              )}

              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "95%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "20px",
                }}
                onClick={() => this.setState({ RecomendedItemDrawer: false })}
              >
                {" "}
                DISMISS{" "}
              </button>
            </>
          }
          size={isMobile ? "85%" : 280}
          Heading="FREQUENTLY BOUGHT TOGETHER"
        />
      </div>
    );
  }

  async LoadProduct() {
    try {
      this.setState({ IsLoading: true });
      let MID = dto_selected_merchant_or_product.MID;
      if (MID === undefined && CSP === "MK") {
        MID = 6;
        dto_selected_merchant_or_product.MID = MID;
      }

      if (this.state.FromPage.toUpperCase() === "CART") {
        MID = dto_selected_final_merchant_or_product.MID;
      }
      let data = await api_LoadProductToPID(MID, this.state.PID);
      let objData = JSON.parse(data);

      await this.SetLineIdNAddOnLineId();
      this.setState(
        {
          ProductAddOnList: objData.dtoProductAddOnList,
          Product: objData.dtoProductSessionList[0],
          ProductImageUrl: objData.dtoProductSessionList[0].IU.split("λ")[0],
          HasProductImage: Boolean(
            String(objData.dtoProductSessionList[0].IU.split("λ")[0] || "").trim(),
          ),
          ProductUOMList: objData.dtoProductUOMList,
          IsLoading: false,
          DetailProdutUP: objData.dtoProductSessionList[0].P,
          ProductDesc: objData.dtoProductSessionList[0].D,
        },
        async () => {
          await this.calculation();
          await HEADER_TAB_SETUP({
            HeaderTabName: CONCAT_TEXT_LIMIT({
              length: 20,
              string: this.state.ProductDesc,
            }),
            FnGoBackScreen: async () => {
              await this.PathDivert();
            },
            HeaderNavigatorMenuDisplay: false,
            FnHeaderNavigatorMenu: () => {},
          });
          await this.AddonUom(
            objData.dtoProductSessionList[0],
            objData.dtoProductAddOnList,
            objData.dtoProductUOMList,
          );
          this.SetModificationAndQtyFromStorageCart(
            objData.dtoProductSessionList[0],
          );
        },
      );
    } catch (error) {
      console.error("LoadProduct : ", error);
    }
  }

  async SetModificationAndQtyFromStorageCart(objectProduct) {
    let Cart = await GET_CART();
    this.CartCache = Array.isArray(Cart) ? Cart : [];
    if (Cart === undefined || Cart.length === 0) {
      return;
    }

    const matchedCartItem = this.getMatchedCartItem(Cart, objectProduct);
    if (matchedCartItem) {
      this.setState(
        {
          Qty: matchedCartItem.Qty,
          Note: this.extractNoteFromModification(matchedCartItem.Modification),
          LineID: matchedCartItem.LineID,
          AddonLineID: matchedCartItem.ADDONLINEID || matchedCartItem.LineID,
        },
        async () => {
          await this.calculation();
        },
      );
      return;
    }

    if (!this.isEditingCartLine()) {
      return;
    }

    if (Cart !== undefined) {
      if (Cart.length > 0) {
        for (var i = 0; i < Cart.length; i++) {
          if (Cart[i].MID === objectProduct.MID) {
            if (parseInt(Cart[i].LineID) === parseInt(this.state.LineID)) {
              var dataNote = Cart[i].Modification.substring(
                Cart[i].Modification.lastIndexOf("µµ") + 2,
                Cart[i].Modification.lastIndexOf("µ"),
              ).toString();
              if (dataNote === "µ") {
                dataNote = "";
              }
              this.setState(
                {
                  Qty: Cart[i].Qty,
                  Note: dataNote,
                },
                async () => {
                  await this.calculation();
                },
              );

              return;
            }
          }
        }
      }
    }
  }

  isEditingCartLine() {
    return String(this.state.FromPage || "").toUpperCase() === "CART";
  }

  extractNoteFromModification(modification = "") {
    const normalizedModification = String(modification || "")
      .split("Ã‚Âµ")
      .join("Âµ");
    const noteAndMeta = normalizedModification.split("ÂµÂµ")[1] || "";
    const note = noteAndMeta.split("Âµ")[0] || "";

    return note === "Âµ" ? "" : note;
  }

  getMatchedCartItem(Cart = [], objectProduct = {}) {
    const targetMid = Number(
      (objectProduct && objectProduct.MID) ||
        (this.state.Product && this.state.Product.MID) ||
        0,
    );
    const targetLineID = Number(this.state.LineID || 0);
    const targetPid = Number(
      (objectProduct && (objectProduct.PI || objectProduct.PID)) ||
        (this.state.Product &&
          (this.state.Product.PI || this.state.Product.PID)) ||
        this.state.PID ||
        0,
    );
    const targetUSeqID = Number(
      this.state.UomSelectedUseqID ||
        (objectProduct && (objectProduct.UI || objectProduct.USeqID)) ||
        (this.state.Product &&
          (this.state.Product.UI || this.state.Product.USeqID)) ||
        0,
    );

    if (this.isEditingCartLine()) {
      const exactLineMatch = Cart.find(
        (cartItem) =>
          Number(cartItem.MID) === targetMid &&
          targetLineID > 0 &&
          Number(cartItem.LineID) === targetLineID,
      );
      if (exactLineMatch) {
        return exactLineMatch;
      }
    }

    return (
      Cart.find((cartItem) => {
        if (Number(cartItem.MID) !== targetMid) {
          return false;
        }
        if (Number(cartItem.PID) !== targetPid) {
          return false;
        }
        if (targetUSeqID > 0) {
          return Number(cartItem.USeqID || 0) === targetUSeqID;
        }
        return true;
      }) || null
    );
  }

  getMatchedCartIndex(Cart = [], ProductInfo = {}) {
    const targetMid = Number(ProductInfo.MID || 0);
    const targetLineID = Number(ProductInfo.LineID || 0);
    const targetPid = Number(ProductInfo.PID || 0);
    const targetUSeqID = Number(ProductInfo.USeqID || 0);

    if (this.isEditingCartLine()) {
      const lineIndex = Cart.findIndex(
        (cartItem) =>
          Number(cartItem.MID) === targetMid &&
          targetLineID > 0 &&
          Number(cartItem.LineID) === targetLineID,
      );
      if (lineIndex !== -1) {
        return lineIndex;
      }
    }

    return Cart.findIndex(
      (cartItem) =>
        Number(cartItem.MID) === targetMid &&
        Number(cartItem.PID) === targetPid &&
        Number(cartItem.USeqID || 0) === targetUSeqID,
    );
  }

  getResolvedUomForProduct(Product, UomList) {
    const productUseqId = parseInt(Product.UI);
    const productPid = parseInt(Product.PI || Product.PID);
    const matchedUom = UomList.find(
      (uom) => parseInt(uom.USeqID) === productUseqId,
    );

    if (matchedUom) {
      return {
        selectedUseqId: matchedUom.USeqID,
        uom: matchedUom,
      };
    }

    const fallbackUom =
      UomList.find((uom) => parseInt(uom.PID) === productPid) || UomList[0];

    return {
      selectedUseqId: Product.UI,
      uom: fallbackUom,
    };
  }

  getSelectedProductDecPoint(Product = this.state.Product) {
    const selectedUseqId =
      this.state.UomSelectedUseqID || Product?.UI || Product?.USeqID || 0;
    const selectedUom =
      this.state.ProductUOMList.find(
        (uom) => parseInt(uom.USeqID) === parseInt(selectedUseqId),
      ) || null;

    return selectedUom?.DecPoint || Product?.DecPoint || Product?.DP || "n0";
  }

  getSelectedProductPid(Product = this.state.Product) {
    return Product?.PID || Product?.PI || this.state.PID || 0;
  }

  getFilteredProductAddonList(useqid) {
    return this.state.ProductAddOnList.filter(
      (addon) => parseInt(addon.USeqID) === parseInt(useqid),
    );
  }

  async AddonUom(Product, AddonList, UomList) {
    let data = await GET_ADDON_UOM();
    if (data !== undefined) {
      if (this.state.FromPage.toUpperCase() === "CART") {
        var ob = [];
        var useqid = 0;
        if (
          parseInt(Product.MID) ===
          parseInt(dto_selected_final_merchant_or_product.MID)
        ) {
          if (data.length > 0) {
            for (var k = 0; k < data.length; k++) {
              if (
                parseInt(this.state.AddonLineID) === parseInt(data[k].LINEID)
              ) {
                let Qty = data[k].QTY;
                let Description = "";
                const resolvedUom =
                  UomList.find(
                    (uom) => parseInt(data[k].USeqID) === parseInt(uom.USeqID),
                  ) || this.getResolvedUomForProduct(Product, UomList).uom;
                const selectedUomIndex = UomList.findIndex(
                  (uom) =>
                    parseInt(uom.USeqID) === parseInt(resolvedUom?.USeqID),
                );

                if (resolvedUom) {
                  Product.PI = resolvedUom.PID;
                  Product.PID = resolvedUom.PID;
                  if (UomList.length > 1) {
                    Description = Product.Description + "-" + resolvedUom.UOM;
                  } else {
                    Description = Product.Description;
                  }

                  Product.P = resolvedUom.SP;
                  Product.UD = resolvedUom.UD;
                  useqid = data[k].USeqID;
                  ob = data[k].ADDONGUID;
                  var total = 0;
                  var listData = this.state.ProductAddOnList;
                  var objFillteredProductAddonList =
                    this.getFilteredProductAddonList(useqid);

                  if (ob.length > 0) {
                    for (let m = 0; m < listData.length; m++) {
                      var dtoDTOProductAddOnDetailList =
                        listData[m].dtoDTOProductAddOnDetailList;
                      for (
                        let p = 0;
                        p < dtoDTOProductAddOnDetailList.length;
                        p++
                      ) {
                        if (
                          parseInt(useqid) === parseInt(listData[m].USeqID)
                        ) {
                          for (let n = 0; n < ob.length; n++) {
                            if (
                              ob[n] ===
                              dtoDTOProductAddOnDetailList[p].MobileUniqueID
                            ) {
                              listData[m].dtoDTOProductAddOnDetailList[
                                p
                              ].IsChecked = true;

                              total =
                                parseFloat(total) +
                                parseFloat(
                                  listData[m].dtoDTOProductAddOnDetailList[p]
                                    .Price,
                                );
                              this.setState({
                                ClearAddonsTrue: "NO",
                              });
                            }
                          }
                        }
                      }
                    }
                  }
                  await this.setState(
                    {
                      ProductDesc: Description,
                      DetailProdutUP: resolvedUom.SP,
                      Product: Product,
                      Total: total,
                      ProductAddOnList: listData,
                      selectedUomRadioButton:
                        selectedUomIndex >= 0 ? selectedUomIndex + 1 : 1,
                      ClearAddonsTrue: "NO",
                      FillteredProductAddonList: objFillteredProductAddonList,
                      Qty: Qty,
                      UomSelectedUseqID: useqid,
                      AddonSelectedGUID: ob,
                    },
                    async () => {
                      await this.calculation({ Qty: this.state.Qty });
                    },
                  );
                  break;
                }
              } else {
                await this.SetAddonUom(Product, AddonList, UomList);
              }
            }
          } else {
            await this.SetAddonUom(Product, AddonList, UomList);
          }
        }
      } else {
        await this.SetAddonUom(Product, AddonList, UomList);
      }
    } else {
      await this.SetAddonUom(Product, AddonList, UomList);
    }
    await this.calculation({ Qty: this.state.Qty });
  }

  async SetAddonUom(Product, AddonList, UomList) {
    let selectedUomRadioButton = 1;
    let Description = "";

    const { selectedUseqId, uom } = this.getResolvedUomForProduct(
      Product,
      UomList,
    );

    if (uom) {
      Product.PI = uom.PID;
      Product.PID = uom.PID;
      Product.P = uom.SP;
      Product.UD = uom.UD;
      Product.UI = uom.USeqID;
      Product.U = uom.UOM;
      Product.DP = uom.DecPoint || Product.DP;
      Product.DecPoint = uom.DecPoint || Product.DecPoint;
      if (UomList.length > 1) {
        Description = Product.D + "-" + uom.UOM;
      } else {
        Description = Product.D;
      }
      const fillteredProductAddonList =
        AddonList.length > 0
          ? this.getFilteredProductAddonList(selectedUseqId)
          : [];
      const matchedUomIndex = UomList.findIndex(
        (item) => parseInt(item.USeqID) === parseInt(uom.USeqID),
      );

      selectedUomRadioButton = matchedUomIndex >= 0 ? matchedUomIndex + 1 : 1;
      this.setState({
        MaxAddOnSelection: uom.MaxAddOnSelection,
        UomSelectedUseqID: selectedUseqId,
        ProductDesc: Description,
        selectedUomRadioButton: selectedUomRadioButton,
        FillteredProductAddonList: fillteredProductAddonList,
      });
    }
  }

  async SetModification() {
    if (
      this.state.Note === "" &&
      this.state.AddOnDesc === "" &&
      this.state.AddonPIDUseqID === ""
    ) {
      return "";
    } else {
      return (
        this.state.AddOnDesc +
        "µµ" +
        this.state.Note +
        "µ" +
        this.state.AddonPIDUseqID
      );
    }
  }

  ClickUOMRadioButton = async (e, rs, i) => {
    var value = this.state.ClearAddonsTrue;
    let Product = this.state.Product;
    let UP = 0;
    let ProductDescription = "";
    if (value === "YES") {
      await this.setIschekedFalseForMainData();
    }

    Product.PI = rs.PID;
    Product.PID = rs.PID;
    Product.P = rs.SP;
    Product.UD = rs.UD;
    Product.UI = rs.USeqID;
    Product.U = rs.UOM;
    Product.DP = rs.DecPoint || Product.DP;
    Product.DecPoint = rs.DecPoint || Product.DecPoint;
    UP = rs.SP;

    if (this.state.ProductUOMList.length > 1) {
      ProductDescription = Product.D + "-" + rs.UOM;
    }
    let FillteredProductAddonList = [];
    let ProdcutAddonList = this.state.ProductAddOnList;

    for (let j = 0; j < ProdcutAddonList.length; j++) {
      if (ProdcutAddonList[j].USeqID === rs.USeqID) {
        FillteredProductAddonList.push(ProdcutAddonList[j]);
      }
    }

    this.setState(
      {
        MaxAddOnSelection: rs.MA,
        UomSelectedUseqID: rs.USeqID,
        Product: Product,
        FillteredProductAddonList: FillteredProductAddonList,
        selectedUomRadioButton: i + 1,
        ProductDesc: ProductDescription,
        DetailProdutUP: UP,
        ClearAddonsTrue: "YES",
        Total: 0,
      },
      async () => {
        await this.calculation();
      },
    );
  };

  async setIschekedFalseForMainData() {
    var listData = this.state.ProductAddOnList;
    if (listData.length > 0) {
      for (let i = 0; i < listData.length; i++) {
        for (
          let d = 0;
          d < listData[i].dtoDTOProductAddOnDetailList.length;
          d++
        ) {
          if (listData[i].dtoDTOProductAddOnDetailList[d].IsChecked === true) {
            listData[i].dtoDTOProductAddOnDetailList[d].IsChecked = false;
          }
        }
      }
      this.setState({ ProductAddOnList: listData });
    }
  }

  SelectAddonCheckbox(item, data) {
    let changedCheckbox = item.dtoDTOProductAddOnDetailList.find(
      (cb) => cb.AddOnUSeqID === data.AddOnUSeqID,
    );
    changedCheckbox.IsChecked = !changedCheckbox.IsChecked;
    var chkboxes = item.dtoDTOProductAddOnDetailList;
    var j = 1;
    for (let index = 0; index < chkboxes.length; index++) {
      if (chkboxes[index].IsChecked) {
        if (item.MaxAddOnSelection !== 0) {
          if (item.MaxAddOnSelection < j) {
            changedCheckbox.IsChecked = false;
            j = j - 1;

            ToastMessage(
              1,
              "Can select only " +
                item.MaxAddOnSelection +
                " from " +
                item.AddOnDesc +
                ".",
            );

            break;
          }
        }
        j++;
      }
    }
    this.calculation();
  }

  onNoteChange(value) {
    if (value.indexOf("\n") !== -1) {
      return;
    }
    if (value === "") {
      this.setState({
        Note: "",
      });
    } else {
      this.setState({
        Note: value,
      });
    }
  }

  async onChangeQty(type) {
    let cantd = this.state.Qty;
    let MaxQty = this.state.Product.Q;
    if (type) {
      if (MaxQty === 0) {
        cantd = cantd + 1;
        this.setState({ Qty: cantd }, async () => {
          await this.calculation();
        });
      } else {
        if (MaxQty <= cantd) {
          ToastMessage(
            1,
            "Sorry, due to limited stock availability this is the maximum quantity you can purchase at the moment",
          );

          this.setState({ count: 0 }, async () => {
            await this.calculation();
          });
          return;
        } else {
          cantd = cantd + 1;
          this.setState({ Qty: cantd }, async () => {
            await this.calculation();
          });
        }
      }
    } else if (type === false && cantd >= 2) {
      cantd = cantd - 1;
      this.setState({ Qty: cantd }, async () => {
        await this.calculation();
      });
    } else if (type === false && cantd === 1) {
      this.setState({ Qty: 1 }, async () => {
        await this.calculation();
      });

      ToastMessage(1, "Invalid quantity");
    }
  }

  async calculation() {
    await this.SetAddonsafterSelectCheckBox();
    var Total = 0;
    var extracost = 0;
    extracost = this.state.Total * this.state.Qty + this.state.HandlingCost;
    Total =
      (this.state.Total +
        this.state.HandlingCost +
        (this.state.DetailProdutUP - this.state.Product.UD)) *
      this.state.Qty;
    this.setState(
      { done: 1, DisplayGrantTotal: Total, Total: extracost },
      async () => {
        await this.DisplayBtnFooterOptions();
      },
    );
  }

  async SetAddonsafterSelectCheckBox() {
    var chkboxes = this.state.FillteredProductAddonList;
    let addonDesc = "";
    let addonPIDUseqIDMake = "";
    var text = "";
    var addonPIDUseqID = "";
    var Total = 0;
    var ADDONGUID = [];
    var SelectedCheckBoxArray = [];

    for (let index = 0; index < chkboxes.length; index++) {
      var data = chkboxes[index].dtoDTOProductAddOnDetailList;
      var SelectedNuber = 0;
      for (let k = 0; k < data.length; k++) {
        if (data[k].IsChecked) {
          text += data[k].AddOnProductDesc + "¥" + this.state.Qty + "|";
          addonPIDUseqID +=
            data[k].AddOnPID +
            "¥" +
            data[k].AddOnUSeqID +
            "¥" +
            this.state.Qty +
            "¥" +
            data[k].Price +
            "|";
          ADDONGUID.push(data[k].MobileUniqueID);
          SelectedNuber = parseInt(SelectedNuber + 1);
          Total = +parseFloat(Total) + parseFloat(data[k].Price);
        }
      }
      var pushSelected = {
        GUID: chkboxes[index].GUID,
        SelectedNuber: SelectedNuber,
      };
      SelectedCheckBoxArray.push(pushSelected);
    }
    if (text.length > 0) {
      addonDesc = text.slice(0, -1);
    } else {
      addonDesc = text;
    }
    if (addonPIDUseqID.length > 0) {
      addonPIDUseqIDMake = addonPIDUseqID.slice(0, -1);
    } else {
      addonPIDUseqIDMake = addonPIDUseqID;
    }
    await this.setState({
      done: 0,
      SelectedNuberArray: SelectedCheckBoxArray,
      AddOnDesc: addonDesc,
      AddonPIDUseqID: addonPIDUseqIDMake,
      AddonSelectedGUID: ADDONGUID,
      Total: Total,
    });
  }

  async DisplayBtnFooterOptions() {
    let data = undefined;
    if (this.state.FromPage.toUpperCase() === "CART") {
      data = await GET_CART_SELECT_MERCHATS_ZONE();
    } else {
      data = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
    }
    if (data !== undefined) {
      if (data.IO === false) {
        this.setState({
          disabled: true,
          BtnDisableClr: "red",
          BtnDescription: "MERCHANT CLOSED",
        });
      } else {
        if (this.state.Product.A !== false) {
          this.setState({
            disabled: false,
            BtnDisableClr: Colors.DarkGreyScale, //zeena
            BtnDescription:
              "ADD TO CART" +
              "  -  " +
              dto_StartupPageLoadInfo.Currency +
              " " +
              this.state.DisplayGrantTotal.toFixed(2).replace(
                /(\d)(?=(\d{3})+(?!\d))/g,
                "$1,",
              ),
          });
        } else {
          this.setState({
            disabled: true,
            BtnDisableClr: "#95afc0",
            BtnDescription: "SOLD OUT",
          });
        }
      }
    }
  }

  async SetLineIdNAddOnLineId() {
    if (this.state.FromPage.toUpperCase() !== "CART") {
      let Cart = await GET_CART();
      this.CartCache = Array.isArray(Cart) ? Cart : [];
      if (Cart !== undefined) {
        if (Cart.length > 0) {
          if (
            parseInt(dto_selected_merchant_or_product.MID) ===
            parseInt(Cart[0].MID)
          ) {
            await this.setState({
              LineID: Cart.length + 1,
              AddonLineID: Cart.length + 1,
            });
          } else {
            await this.setState({ LineID: 1, AddonLineID: 1 });
          }
        } else {
          await this.setState({ LineID: 1, AddonLineID: 1 });
        }
      } else {
        await this.setState({ LineID: 1, AddonLineID: 1 });
      }
    } else {
      this.setState({
        LineID: this.state.LineID,
        AddonLineID: this.state.AddonLineID,
      });
    }
  }

  async validationCheckAddons() {
    var Addons = this.state.FillteredProductAddonList;
    var SelectedNuberArray = this.state.SelectedNuberArray;
    var rtdata = "proceed";

    if (Addons.length !== 0) {
      for (let i = 0; i < Addons.length; i++) {
        if (Addons[i].IsMustSelect !== false) {
          let addonSelected = false;
          for (let k = 0; k < SelectedNuberArray.length; k++) {
            if (
              SelectedNuberArray[k].GUID === Addons[i].GUID &&
              SelectedNuberArray[k].SelectedNuber > 0
            ) {
              addonSelected = true;
              break;
            }
          }
          if (!addonSelected) {
            rtdata = "Please select from " + Addons[i].AddOnDesc;
            return rtdata;
          }
        }
      }
      rtdata = "proceed";
    } else {
      rtdata = "proceed";
    }
    return rtdata;
  }

  async setStorageADDONUOM(lineID = this.state.LineID) {
    let ADDONUOM = await GET_ADDON_UOM();
    var ob = [];
    let data = {
      LINEID: lineID,
      PID: this.getSelectedProductPid(),
      USeqID: this.state.UomSelectedUseqID,
      ADDONGUID: this.state.AddonSelectedGUID,
      QTY: this.state.Qty,
    };
    if (ADDONUOM !== undefined) {
      if (ADDONUOM.length > 0) {
        ob = [...ADDONUOM];
        const existingIndex = ob.findIndex(
          (item) => parseInt(item.LINEID) === parseInt(lineID),
        );
        if (existingIndex !== -1) {
          ob[existingIndex] = data;
        } else {
          ob.push(data);
        }
        await SET_STORE_ADDONUOM(ob);
        return;
      }
    } else {
      ob = [data];
      await SET_STORE_ADDONUOM(ob);
      return;
    }
    ob.push(data);
    await SET_STORE_ADDONUOM(ob);
  }

  async onClickAddCart(data) {
    let addtoproduct = true;
    var da = await this.validationCheckAddons();
    if (da === "proceed") {
      if (this.state.ProductUOMList.length > 1) {
        if (this.state.selectedUomRadioButton === 0) {
          ToastMessage(1, "SELECT OPTIONS");

          return;
        }
      }

      if (addtoproduct === true) {
        let today = new Date();
        let yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);

        let isReacomended = this.state.isReacomended;
        if (isReacomended === undefined) {
          isReacomended = 0;
        }
        const ProductInfo = {
          LineID: this.state.LineID,
          PID: this.getSelectedProductPid(data),
          TID: data.TI,
          Code: data.C,
          ProductImageUrl: data.IU,
          Desc: data.D,
          USeqID: data.UI,
          UOM: data.U,
          UP: data.P,
          UD: data.UD,
          Qty: this.state.Qty,
          DecPoint: this.getSelectedProductDecPoint(data),
          Total: 0,
          Modification: await this.SetModification(),
          ExtraCost: this.state.Total,
          DocDiscount: 0,
          VAT: 0,
          TAXID: data.TA,
          TaxEquation: data.TE || "SUM * 0/100",
          MID: data.MID,
          GDescription: data.G,
          IsAvailable: data.A,
          ADDONLINEID: this.state.AddonLineID,
          UDPer: 0,
          IsRecommended: isReacomended,
        };

        let CartList = Array.isArray(this.CartCache)
          ? [...this.CartCache]
          : await GET_CART();
        this.CartCache = Array.isArray(CartList) ? CartList : [];

        if (CartList === undefined || CartList.length === 0) {
          await this.CartAddNewItemList(CartList, ProductInfo, 0);
        } else {
          if (CartList.length > 0) {
            const cartMerchantMid = Number(CartList[0]?.MID);
            const productMerchantMid = Number(ProductInfo.MID);

            if (
              Number.isFinite(cartMerchantMid) &&
              Number.isFinite(productMerchantMid) &&
              cartMerchantMid !== productMerchantMid
            ) {
              Alert.ConfirmationMessageBox({
                Tittle: "Change Merchant",
                Text: "Selecting a different Merchant will clear your current cart. Do you wish to continue?",
                Icon: "warning",
                ConfirmButtonText: "Yes",
                ConfirmButtonFunction: async () => {
                  await this.CartChangeMerchant(CartList, ProductInfo, -1);
                  await SET_STORE_CART_SELECT_MERCHATS_ZONE(
                    dto_selected_merchant_or_product,
                  );
                  ENCRYPT_STORAGE.removeMultipleItems([
                    STORE_SHEDULEDateNTime,
                    STORE_CartCheckoutData,
                    STORE_DineType,
                  ]);
                  dto_cart_checkout.PromoHeader = "";
                  dto_cart_checkout.PromoGuid = 0;
                  dto_cart_checkout.PromoCODE = "";
                  dto_cart_checkout.DiscountPersentage = 0;
                  dto_cart_checkout.DiscountTotal = 0;
                  dto_cart_checkout.Comment = "";
                },
                DismissButtonFunction: () => {},
              });
              return;
            }

            if (this.isEditingCartLine()) {
              const matchedCartIndex = this.getMatchedCartIndex(
                CartList,
                ProductInfo,
              );
              if (matchedCartIndex !== -1) {
                ProductInfo.LineID = CartList[matchedCartIndex].LineID;
                ProductInfo.ADDONLINEID =
                  CartList[matchedCartIndex].ADDONLINEID ||
                  CartList[matchedCartIndex].LineID;
                await new Promise((resolve) => {
                  this.setState(
                    {
                      LineID: ProductInfo.LineID,
                      AddonLineID: ProductInfo.ADDONLINEID,
                    },
                    resolve,
                  );
                });
                await this.CartAddNewItemList(
                  CartList,
                  ProductInfo,
                  matchedCartIndex,
                );
                return;
              }
            }
            await this.CartAddNewItemList(CartList, ProductInfo, -1);
          }
        }
      }
    } else {
      ToastMessage(1, da);
      return;
    }
  }

  async CartAddNewItemList(CartList, ProductInfo, i) {
    const isInitialCart = !Array.isArray(CartList) || CartList.length === 0;
    const nextCartList = Array.isArray(CartList) ? [...CartList] : [];

    if (i === -1 || (i === 0 && isInitialCart)) {
      nextCartList.push(ProductInfo);
    } else {
      nextCartList[i] = ProductInfo;
    }

    const normalizedCartList = this.SetCartLineId(nextCartList);
    this.CartCache = normalizedCartList;
    const updatedItemIndex =
      i === -1 || (i === 0 && isInitialCart) ? normalizedCartList.length - 1 : i;
    const persistedProductInfo = normalizedCartList[updatedItemIndex];

    if (isInitialCart) {
      await SET_STORE_CART_SELECT_MERCHATS_ZONE(
        dto_selected_merchant_or_product,
      );
    }
    await SET_STORE_CART(normalizedCartList);

    void this.setStorageADDONUOM(
      persistedProductInfo?.LineID || this.state.LineID,
    );
    void GET_CART_COUNT(normalizedCartList);
    this.NavigateToPageAfterAddtoCartClick();
    return;
  }

  async CartChangeMerchant(CartList, ProductInfo, i) {
    CartList = [];
    this.CartCache = [];
    CLEAR_CART_MEMORY_CACHE();
    await ENCRYPT_STORAGE.removeMultipleItems([
      STORE_Cart,
      STORE_Addons,
      STORE_FinaleSelelctCartMerchantNZone,
    ]);
    await this.CartAddNewItemList(CartList, ProductInfo, i);
  }

  SetCartLineId(CartItemList = []) {
    if (!Array.isArray(CartItemList)) {
      return [];
    }

    return CartItemList.map((cartItem, index) => ({
      ...cartItem,
      LineID: index + 1,
    }));
  }

  NavigateToPageAfterAddtoCartClick() {
    if (this.state.FromPage?.toUpperCase() === "CART") {
      this.PathDivert();
      return;
    }

    if (dto_StartupPageLoadInfo.IsMLProduct === true) {
      if (CSP === "DT" && dto_selected_merchant_or_product.MID === 6) {
        this.PathDivert();
      } else {
        ToastMessage(2, "Item Added");
        this.PathDivert();
      }
    } else {
      this.PathDivert();
    }
  }

  PathDivert() {
    if (this.state.FromPage?.toUpperCase() === "CART") {
      this.props.navigate(PT_CART);
      return;
    }

    if (this.state.NavigatePage === "home") {
      this.props.navigate(PT_HOME);
    } else if (this.state.NavigatePage === "home-filter") {
      this.props.navigate("/home/filter");
    } else {
      if (this.state.FromPage.toUpperCase() === "CATE") {
        this.props.navigate("MasterCategorypage");
      } else {
        this.props.navigate("/" + this.state.NavigatePage);
        this.props.navigate(
          PT_GROCERY_PRODUCT_LIST.replace(
            ":navPage",
            this.state.NavigatePage === "home-filter"
              ? this.state.NavigatePage
              : "none",
          ),
        );
      }
    }
  }
}
